import { useEffect, useRef, useState } from 'react';

export function useDelayedVisibility(
  active: boolean,
  {
    showDelay = 200,
    minDuration = 1_000,
  }: { showDelay?: number; minDuration?: number } = {},
) {
  const instant = showDelay === 0 && minDuration === 0;
  const [visible, setVisible] = useState(false);
  const shownAt = useRef<number | null>(null);

  useEffect(() => {
    if (instant) return;

    if (active) {
      if (visible) return;

      const t = setTimeout(() => {
        setVisible(true);
        shownAt.current = Date.now();
      }, showDelay);
      return () => clearTimeout(t);
    }

    if (!visible) return;

    const elapsed = Date.now() - (shownAt.current ?? 0);
    const remaining = Math.max(0, minDuration - elapsed);

    const t = setTimeout(() => {
      setVisible(false);
      shownAt.current = null;
    }, remaining);
    return () => clearTimeout(t);
  }, [active, showDelay, minDuration, visible, instant]);

  return instant ? active : visible;
}
